import { Block } from "./block"
import { Piece } from "./pieces"
import { Matrix } from "./matrix"

import { PIECES } from "./constants"


class Table extends Block {

    points: number
    isFinished: boolean
    pieceAmount: number
    pieces: Array<Piece>

    constructor (rowAmount: number, colAmount: number, pieceAmount: number) {
        super(new Matrix<string | boolean | null>(rowAmount, colAmount, null))
        this.points = 0
        this.isFinished = false
        this.pieceAmount = pieceAmount
        this.pieces = this.getRandomPieces(this.pieceAmount)
    }

    put (piece: Piece, row: number, column: number): void {
        this.fit(piece, row, column)
        this.del()
        this.update()
    }

    update (): void {
        this.pieces = this.getRandomPieces(this.pieceAmount)
        let notFittable = 0
        for (const piece of this.pieces) {
            if (piece.disabled)
                notFittable ++
        }
        if (notFittable == this.pieceAmount)
            this.isFinished = true
    }

    getRandomPieces (amount: number): Array<Piece> {
        const pieces: Array<Piece> = []
        while (pieces.length < amount) {
            const piece = PIECES[Math.floor(Math.random() * PIECES.length)]
            piece.disabled = this.isNever(piece)
            pieces.push(piece)
        }
        return pieces
    }

    isNever (piece: Piece): boolean {
        for (let i = 0; i < this.rowAmount - piece.rowAmount + 1; i ++) {
            for (let j = 0; j < this.colAmount - piece.colAmount + 1; j ++) {
                if (this.isFittable(piece, i, j)) {
                    return false
                }
            }
        }
        return true
    }

    isFittable (piece: Piece, row: number, column: number): boolean {
        if (row + piece.rowAmount > this.rowAmount || column + piece.colAmount > this.colAmount)
            return false
        for (let i = 0; i < piece.rowAmount; i ++) {
            for (let j = 0; j < piece.colAmount; j ++) {
                if (piece.matrix[i][j] && this.matrix[row + i][column + j])
                    return false
            }
        }
        return true
    }

    fit (piece: Piece, row: number, column: number): void {
        if (!this.isFittable(piece, row, column))
            throw new RangeError("Piece does not fit")
        for (let i = 0; i < piece.rowAmount; i ++) {
            for (let j = 0; j < piece.colAmount; j ++) {
                if (piece.matrix[i][j])
                    this.matrix[row + i][column + j] = piece.color
            }
        }
    }

    del (): void {
        for (let i = 0; i < this.rowAmount; i ++) {
            let valids = 0
            for (let j = 0; j < this.colAmount; j ++) {
                if (this.matrix[i][j])
                    valids ++
            }
            if (valids == this.colAmount) {
                for (let j = 0; j < this.colAmount; j ++)
                    this.matrix[i][j] = null
                this.points += this.colAmount
            }
        }
        for (let j = 0; j < this.colAmount; j ++) {
            let valids = 0
            for (let i = 0; i < this.rowAmount; i ++) {
                if (this.matrix[i][j])
                    valids ++
            }
            if (valids == this.rowAmount) {
                for (let i = 0; i < this.rowAmount; i ++)
                    this.matrix[i][j] = null
                this.points += this.rowAmount
            }
        }
    }

    reset (): void {
        this.matrix = new Matrix<string | boolean | null>(this.rowAmount, this.colAmount, null)
        this.points = 0
        this.isFinished = false
        this.pieces = this.getRandomPieces(this.pieceAmount)
    }

}

export { Table }
